module.exports = __webpack_public_path__ + "img/15-about.66ead6ef.jpg";